import { Accounts } from "app/utils/hyperlinkUtil";
import { FormattedMessage } from "react-intl";

function AccountDetailsConfirmText() {
  return (
    <div className={"register-screen__account-details"}>
      <FormattedMessage
        tagName="span"
        id="home-register-please-confirm-you-are-aware-of-our"
      />{" "}
      <a href={Accounts.REQUIRED_DOCUMENTS} target="_new">
        <FormattedMessage
          tagName="span"
          id="home-register-account-verification-requirements"
        />
      </a>{" "}
      <FormattedMessage tagName="span" id="home-register-and" />{" "}
      <a href={Accounts.MINIMUN_DEPOSIT_REQUIREMENTS} target="_new">
        <FormattedMessage
          tagName="span"
          id="home-register-first-time-deposit-requirement"
        />
      </a>
    </div>
  );
}

export default AccountDetailsConfirmText;
